var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconModuleVideos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7 7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.364,59.325a22.608,22.608,0,1,1,22.609-22.609A22.634,22.634,0,0,1,297.364,59.325Zm0-43.232a20.624,20.624,0,1,0,20.625,20.623A20.648,20.648,0,0,0,297.364,16.093Z",
    transform: "translate(-274.755 -14.109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.616,44.692a3.329,3.329,0,0,1-3.335-3.327V26.329A3.331,3.331,0,0,1,289.609,23h0a3.329,3.329,0,0,1,1.733.487l12.294,7.52a3.33,3.33,0,0,1,0,5.681L291.346,44.2A3.307,3.307,0,0,1,289.616,44.692Zm-.007-19.707a1.347,1.347,0,0,0-1.344,1.345V41.365a1.346,1.346,0,0,0,2.046,1.147L302.6,35a1.371,1.371,0,0,0,.448-.448A1.345,1.345,0,0,0,302.6,32.7h0L290.31,25.182a1.344,1.344,0,0,0-.7-.2Z",
    transform: "translate(-271.035 -11.239)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModuleVideos);
export default __webpack_public_path__ + "static/media/icon_module_videos.a78fb0c95b757d32a2b4cb85ed77b15d.svg";
export { ForwardRef as ReactComponent };